import { useFeatureGate } from '@statsig/react-bindings';
import { useEffect } from 'react';
import { useMatch } from 'react-router-dom';

import {
  type Brand,
  DEFAULT_BRAND_BY_SURFACE,
  type Surface,
  resolveActiveBrand,
  useUpdateActiveBrand,
} from '@growtherapy/tailwind/react';

import { PROVIDER_PATH } from '../../config';
import { arc2026Rebrand } from '../../statsig/gates';

export function useSyncGrowBranding() {
  const isProviderView = Boolean(useMatch(PROVIDER_PATH));
  const surface: Surface = isProviderView ? 'provider' : 'client';

  const updateActiveBrand = useUpdateActiveBrand(surface);
  const { value: arcRebrandActive } = useFeatureGate(arc2026Rebrand);

  useEffect(() => {
    const activeBrand = resolveActiveBrand();
    const expectedInitialBrand: Brand = arcRebrandActive ? 'arc' : DEFAULT_BRAND_BY_SURFACE[surface];

    if (activeBrand !== expectedInitialBrand) {
      updateActiveBrand(expectedInitialBrand);
    }
    // NOTE: Until the Arc rebrand is fully launched, this dependency array should have a single
    // listed dependency on the rebrand feature flag. After launch, this should be a zero-dependency
    // effect.
    //
    // This is a one time client-side initialization to ensure that the default branding that was
    // set on page load matches our expected default brand for this surface area.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arcRebrandActive]);
}
